<template>
  <div class="product-check-box">
    <div class="content">
      <article class="declare-article declare-article-1">
        <p>尊敬的投资者：</p>
        <p>
          《证券公司及基金管理公司子公司资产证券化业务管理规定》第二十九条规定“资产支持证券应当面向合格投资者发行，发行对象不得超过二百人，单笔认购不少于100
          万元人民币发行面值或等值份额。合格投资者应当符合《私募投资基金监督管理暂行办法》规定的条件。”
          第四十五条规定 “
          管理人及其他信息披露义务人应当按照相关规定在证券交易场所或中国基金业协会指定的网站向合格投资者披露信息。”
        </p>
        <br />
        <p>
          《私募投资基金监督管理暂行办法》第十四条规定“私募基金管理人、私募基金销售机构不得向合格投资者之外的单位和个人募集资金，不得通过报刊、电台、电视、互联网等公众传播媒体或者讲座、报告会、分析会和布告、传单、手机短信、微信、博客和电子邮件等方式，向不特定对象宣传推介。”
        </p>
        <br />
        <p>
          中国国际金融股份有限公司谨遵《证券公司及基金管理公司子公司资产证券化业务管理规定》、《私募投资基金监督管理暂行办法》之规定，仅向合格投资者推介和披露相关产品信息。
        </p>
      </article>

      <div class="form-area">
        <a-form
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :model="state.formInline"
          @submit.prevent="handleSubmit"
        >
          <a-form-item
            label="请输入产品密码浏览产品信息:"
            v-bind="validateInfos.password"
          >
            <a-input
              v-model:value="state.formInline.password"
              placeholder="请输入产品密码"
              class="password-input-style"
            ></a-input>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              class="submit-st"
              :loading="state.loading"
              block
              >提交</a-button
            >
          </a-form-item>
        </a-form>
      </div>

      <article class="declare-article declare-article-2">
        <p>
          如您有意投资相关产品，需符合《私募投资基金监督管理暂行办法》关于“合格投资者”之规定，即具备相应风险识别能力和风险承担能力且投资于单只私募基金的金额不低于100
          万元，并符合如下标准：如您为单位，净资产不低于1000
          万元；如您为个人，金融资产不低于300
          万元或者最近三年个人年均收入不低于50
          万元（金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等）。
        </p>
        <br />
        <p>
          如需进一步浏览相关产品信息，请通过以下方式与我们联系：
          <a href="mailto:IB_BTrustees_ABS@cicc.com.cn"
            >IB_BTrustees_ABS@cicc.com.cn</a
          >。谢谢！
        </p>
      </article>
    </div>
  </div>
  <Verify
    ref="verify"
    mode="pop"
    captchaType="clickWord"
    @success="handleVerifySuccess"
  ></Verify>
</template>

<script setup>
import { reactive, onMounted, ref, toRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Form, message } from "ant-design-vue";

import { errorCaptured } from "@/utils/commonUtil.js";
import api from "@/api/index";
import Verify from "@/components/verifition/verify.vue";
import { storageFn } from "@/utils";

const route = useRoute();
const router = useRouter();
const useForm = Form.useForm;

const labelCol = {
  span: 24,
};
const wrapperCol = {
  span: 24,
};

const verify = ref(null);

const state = reactive({
  fileId: null,
  loading: false,
  captcha: null,
  formInline: {
    password: "",
  },
});

const rulesRef = reactive({
  password: [
    {
      required: true,
      message: "请输入产品密码",
    },
  ],
});

const { validate, validateInfos } = useForm(state.formInline, rulesRef, {
  onValidate: (...args) => console.log(...args),
});

const validateForm = async () => {
  return errorCaptured(
    new Promise((resolve, reject) => {
      validate()
        .then(() => {
          resolve(toRaw(state.formInline));
        })
        .catch((err) => {
          reject(err);
        });
    })
  );
};

const handleSubmit = async () => {
  const [err] = await validateForm();
  if (err) return;
  verify.value.show();
};

const goToDetailPage = () => {
  const id = state.fileId;
  router.push(`/product/${id}/detail`);
};

const handleVerifySuccess = async (res) => {
  state.loading = true;
  const params = {
    productId: state.fileId,
    password: state.formInline.password,
  };
  const [err2, data] = await api.product.verifyPassword(params);
  state.loading = false;
  if (err2) {
    message.error("产品密码错误");
    message.config({
      top: `20%`,
    });
    return;
  }
  storageFn.setSession(state.fileId, data);
  setTimeout(() => {
    goToDetailPage();
  }, 200);
};

onMounted(() => {
  state.fileId = route.params?.fileId;
  // state.fileId =
  // route.params?.fileId == ":fileId" ? "ZJSJY" : route.params?.fileId;
});
</script>

<style lang="scss" scoped>
.product-check-box {
  width: 100%;
  min-height: 100vh;
  background-image: url("~@/assets/img/background-1.png");
  background-size: 100% 100%;
  overflow-y: auto;

  .content {
    width: 62.6%;
    margin: 3% auto;
    border-radius: 10px;
    background: rgba(255, 251, 252, 0.7);
    @media only screen and (max-width: 750px) {
      width: 90%;
    }
    .declare-article {
      color: #333333;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 24px;
      & > p {
        line-height: 24px;
      }
    }

    .declare-article-1 {
      padding: 6% 6% 5% 7%;
    }

    .declare-article-2 {
      padding: 1% 6% 6% 6%;
    }

    .form-area {
      width: 240px;
      margin: 0 auto;
      @media only screen and (max-width: 900px) {
        width: 40%;
      }
      @media only screen and (max-width: 630px) {
        width: 50%;
      }
      @media only screen and (max-width: 430px) {
        width: 90%;
      }
    }
    .submit-st {
      background-color: #910e0e;
      border-radius: 4px;
      border: 1px solid #910e0e;
      margin: 19px 0;
    }

    .password-input-style {
      margin-bottom: 8px;
    }
  }

  ::v-deep(.ant-form-item-label) {
    & > label {
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}

::v-deep(.ant-input:focus) {
  border-color: #910e0e;
  box-shadow: none;
}

::v-deep(.ant-input:hover) {
  border-color: #910e0e;
}

::v-deep(.ant-form-item-explain.ant-form-item-explain-error) {
  color: #d09d57;
}
</style>
